import styled from "@emotion/styled"
import { spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import { Skeleton } from "src/components"

export const SaleAndDeliverySkeleton = () => (
	<Layout>
		<Skeleton.Text />
		<Skeleton.Text />
	</Layout>
)

const Layout = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${spacingStaticXs};
	width: 33%;
`
